import * as React from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';


export default function GamePlayer(props) {
  const [game, setGame] = React.useState(null);
  const [console_core,setConsoleCore] = React.useState(null);
  var game_id = props.id;
  var current_console = JSON.parse(localStorage.getItem("console"+props.consoleId));

  if (console_core == null) {
    if (current_console === null){
      axios.get('https://retrodb.djalim.fr/consoles/' + props.consoleId).then((result) => {
        localStorage.setItem("console"+props.consoleId,JSON.stringify(result.data));
        setConsoleCore(result.data["core"]);
      }) 
    }else{
      setConsoleCore(current_console.core);
    }
  }
  axios.get('https://retrodb.djalim.fr/roms/' + game_id).then((result) => {
    setGame(result.data["name"]);
  })
  function handleDownload(){
    const fileUrl = 'https://retrodb.djalim.fr/roms/' + props.id + '?romfile=true';
    const link = document.createElement('a');
    link.href = fileUrl;
    document.body.appendChild(link);
    link.click();
    // Clean up the temporary URL and remove the <a> element
    document.body.removeChild(link);
  };
  return (
    <div style={{display: "flex",flexDirection:"column",alignItems:"center",width:"100%"}}>
      <h2>GamePlayer</h2>
      <h3>{game}</h3>
      <iframe
        title="EmulatorJS"
        src={"https://retrodb.djalim.fr/emulator?rom_id=" + game_id + "&console_core=" + console_core}
        width="640"
        height="480"
        allowFullScreen
      />
      <Box sx={{
        paddingTop: "10px"
      }}>

      </Box>
      <Button variant="contained" onClick={handleDownload}>Télécharger le jeu</Button>
    </div>
  );
}
